<template>
<div class="chapter">
<div class="inner_page">
<p class="block_15"> </p>
<p class="block_16">To my family. </p>
<p class="block_16">Although it isn’t perfect, it’s mine<span class="calibre3">.  </span></p>
<p class="block_15"> </p>
<p class="block_15"> </p>
<p class="block_14" id="calibre_pb_5"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_005.vue?19b6582a